import pluralize from 'pluralize';
import { memo } from 'react';

import { HelpDropdownButton } from '~/components/HelpDropdownButton';
import { StatusBar } from '~/components/v2/components/shared/status-bar/StatusBar';
import { StatusBarStats } from '~/components/v2/components/shared/status-bar/StatusBarStats';
import { WorkspaceSidebarFooterActivityButton } from '~/components/v2/components/workspace/workspace-sidebar/WorkspaceSidebarFooterActivityButton';
import { useWorkspaceRightPanelStore } from '~/components/v2/store/features/workspace/useWorkspaceRightPanelStore';
import { useWorkspaceSidebarStore } from '~/components/v2/store/features/workspace/useWorkspaceSidebarStore';
import { usePrivateSearchTotals } from '~/swr-hooks/search/usePrivateSearchTotals';

export const WorkspacePageBottombar = memo(() => {
  const isRightPanelOpen = useWorkspaceRightPanelStore((state) => state.open);
  const isSidebarOpen = useWorkspaceSidebarStore((state) => state.open);
  const { total } = usePrivateSearchTotals({ trackLocation: 'workspace-page-bottombar' });

  return (
    <StatusBar>
      <div className="flex items-center gap-2">
        {!isSidebarOpen && <WorkspaceSidebarFooterActivityButton />}
        <span>
          {!!total && (
            <StatusBarStats data-testid="WORKSPACE_PAGE_STATS">{pluralize('item', total, true)}</StatusBarStats>
          )}
        </span>
      </div>
      {!isRightPanelOpen && <HelpDropdownButton />}
    </StatusBar>
  );
});

WorkspacePageBottombar.displayName = 'WorkspacePageBottombar';
